var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footer"}},[(_vm.showCompanyName)?_c('div',{staticClass:"footer-class"},[_c('div',[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.jumpto}},[_vm._v("蜀ICP备17027707号 ")]),_vm._v("| 成都爱维译科技有限公司版权所有")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d40fb12","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/FooterVue/index.vue
// module id = j7oN
// module chunks = 9